import { ExpenseSubmitData } from '../../models/paymentConfig';
import { SavePaymentSubmissionResponse } from '../../models/paymentSubmissions';
import client from '../httpclient';

const savePaymentSubmission = ({
  protocolId,
  paymentCategoryId,
  paymentSubcategoryId,
  expense,
}: {
  protocolId: string;
  paymentCategoryId: string;
  paymentSubcategoryId: string;
  expense?: ExpenseSubmitData;
}): Promise<SavePaymentSubmissionResponse> =>
  client.post('/re/v1/reimbursement-request-or-expense', {
    protocolId,
    paymentCategoryId,
    paymentSubcategoryId,
    expense: expense
      ? { ...expense, expenseCategoryName: undefined } // remove unnecessary field
      : undefined,
  });

export default savePaymentSubmission;
